function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
var CalendarMonth = function CalendarMonth(_ref) {
  var selectedMonth = _ref.selectedMonth,
    weekDays = _ref.weekDays,
    handleSelectDay = _ref.handleSelectDay,
    selectedStartDate = _ref.selectedStartDate,
    selectedEndDate = _ref.selectedEndDate,
    _onMouseEnter = _ref.onMouseEnter,
    _onMouseLeave = _ref.onMouseLeave,
    hoverDate = _ref.hoverDate,
    range = _ref.range;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var daysInMonthArr = function daysInMonthArr(date) {
    return _toConsumableArray(Array(moment(date, 'YYYY-MM-DD').daysInMonth())).map(function (x, i) {
      return moment("".concat(moment(date).format('YYYY'), "-").concat(moment(date).format('MM'), "-").concat(i + 1)).format('YYYY-MM-DD');
    });
  };
  var dayArr = daysInMonthArr(selectedMonth);
  var buffer = weekDays.indexOf(moment(dayArr[0]).format('ddd'));
  return /*#__PURE__*/React.createElement("div", {
    className: "calendar-month"
  }, weekDays.map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(id).concat(x)
    }, /*#__PURE__*/React.createElement("b", null, x.substr(0, 2)));
  }), _toConsumableArray(Array(buffer)).map(function (x, i) {
    return i;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(id).concat(x, "buffer")
    });
  }), dayArr.map(function (x, i) {
    return /*#__PURE__*/React.createElement("div", {
      onMouseEnter: function onMouseEnter() {
        return _onMouseEnter(x);
      },
      onMouseLeave: function onMouseLeave() {
        return _onMouseLeave(x);
      },
      onClick: function onClick() {
        return handleSelectDay(x);
      },
      className: [!range && x === selectedStartDate && 'calendar-month__selected', range && x === selectedStartDate && 'calendar-month__start-date', range && x === selectedEndDate && 'calendar-month__end-date', range && !selectedEndDate && moment(x).isBetween(moment(selectedStartDate), moment(hoverDate)) && 'calendar-month__in-range', range && selectedEndDate && moment(x).isBetween(moment(selectedStartDate), moment(selectedEndDate)) && 'calendar-month__in-range'].join(' '),
      key: "".concat(id).concat(x)
    }, i + 1);
  }));
};
export default CalendarMonth;